var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { PET_TYPE } from '@variables';
var _PROFILE_VERSION_TO_CONTENT_TYPE = {
    juicy: 'subscription_personalized',
    bab: 'subscription_flex',
    otto: 'one_time',
};
var getNumberOfPetsRecipesAndMotivations = function (pets, petSurveys) {
    if (pets.length) {
        // Count number of dogs, cats and recipes to send to FB.
        var numDogs_1 = 0;
        var numCats_1 = 0;
        var recipes_1 = new Set();
        var purchasingMotivations_1 = new Set();
        pets.forEach(function (pet) {
            if (pet.petType === 'CAT') {
                numCats_1++;
            }
            else {
                numDogs_1++;
            }
            if (pet.recipeMix.length) {
                pet.recipeMix.forEach(function (recipe) {
                    if (recipe) {
                        recipes_1.add(recipe);
                    }
                });
            }
            if (pet.recipe) {
                if (typeof pet.recipe === 'string') {
                    recipes_1.add(pet.recipe);
                }
                else if (pet.recipe) {
                    recipes_1.add(pet.recipe.name);
                }
            }
        });
        petSurveys.forEach(function (petSurvey) {
            if (petSurvey.purchasingMotivations) {
                petSurvey.purchasingMotivations.forEach(function (purchasingMotivation) {
                    return purchasingMotivations_1.add(purchasingMotivation);
                });
            }
        });
        return {
            numPets: pets.length,
            numCats: numCats_1,
            numDogs: numDogs_1,
            recipes: Array.from(recipes_1),
            purchasingMotivations: Array.from(purchasingMotivations_1),
        };
    }
};
var buildFacebookProps = function (petsRecipesAndMotivations, firstPet, costPerWeek, version) {
    var props = {};
    if (petsRecipesAndMotivations.numPets) {
        props.num_pets = petsRecipesAndMotivations.numPets;
        props.num_cats = petsRecipesAndMotivations.numCats;
        props.num_dogs = petsRecipesAndMotivations.numDogs;
        props.content_ids = petsRecipesAndMotivations.recipes.concat(petsRecipesAndMotivations.purchasingMotivations);
        // Determine if the first pet is small, medium or large.
        if (firstPet.weight < 20) {
            props.pet_size = 'small';
        }
        else if (firstPet.weight < 40) {
            props.pet_size = 'medium';
        }
        else {
            props.pet_size = 'large';
        }
        // Determine if the first pet is at ideal, over or under weight.
        if (firstPet.weight) {
            if (firstPet.weight === firstPet.currentWeight) {
                props.weight_status = 'ideal';
            }
            else if (firstPet.weight > firstPet.currentWeight) {
                props.weight_status = 'under';
            }
            else if (firstPet.weight < firstPet.currentWeight) {
                props.weight_status = 'over';
            }
        }
        else {
            props.weight_status = 'ideal';
        }
        // Determine if first pet is a puppy.
        props.is_puppy = firstPet.petType === PET_TYPE.DOG && firstPet.isPuppy;
    }
    if (costPerWeek) {
        props.value = costPerWeek;
        props.currency = 'USD';
    }
    props.content_type = _PROFILE_VERSION_TO_CONTENT_TYPE[version];
    return props;
};
var formatFacebookServerProps = function (props) {
    // Format props for Subscribe event.
    var formattedProps = __assign({}, props);
    formattedProps.custom_properties = {};
    var customPropsKeys = [
        'num_pets',
        'num_dogs',
        'num_cats',
        'pet_size',
        'weight_status',
        'is_puppy',
    ];
    customPropsKeys.map(function (key) {
        if (key in props) {
            formattedProps.custom_properties[key] = props[key];
            delete formattedProps[key];
        }
    });
    return formattedProps;
};
export { buildFacebookProps, getNumberOfPetsRecipesAndMotivations, formatFacebookServerProps, };
